import React from 'react';
import { useParams } from 'react-router';
import { Descriptions, Spin, Typography } from 'antd';
import { useQuery } from '@apollo/client';
import { GET_BUDGETS_PROJECT_INFO } from 'gql/budgets';
import DateDisplay from '../../../layout/DateDisplay';
import { CurrencyDisplay } from '../../../layout';

const { Text } = Typography;

const BudgetHeaderCotent = () => {
  const { projectId } = useParams();
  const { data, loading } = useQuery(GET_BUDGETS_PROJECT_INFO, {
    variables: {
      projectIds: [projectId],
      status: 'ALL',
    },
  });

  const project = data?.projects.nodes[0];

  return (
    <Spin spinning={loading}>
      <Descriptions>
        <Descriptions.Item label="Total Project Funding">
          <CurrencyDisplay amount={project?.profile?.totalFunding} />
        </Descriptions.Item>
        <Descriptions.Item label="Approved Funding">
          <CurrencyDisplay amount={project?.profile?.approvedFunding.amount} />
        </Descriptions.Item>
        <Descriptions.Item label="Additional Funding">
          <CurrencyDisplay amount={project?.profile?.totalAdditionalFunding} />
        </Descriptions.Item>
        <Descriptions.Item label="Total Budget Allocation">
          <Text
            type={
              project?.projectBudget.total > project?.profile?.totalFunding
                ? 'danger'
                : ''
            }
          >
            <CurrencyDisplay amount={project?.projectBudget?.total} />
          </Text>
        </Descriptions.Item>
        <Descriptions.Item label="Allocated Approved Funding">
          <Text
            type={
              project?.projectBudget?.approvedFunding >
              project?.profile?.approvedFunding?.amount
                ? 'danger'
                : ''
            }
          >
            <CurrencyDisplay amount={project?.projectBudget?.approvedFunding} />
          </Text>
        </Descriptions.Item>
        <Descriptions.Item label="Allocated Additional Funding">
          <Text
            type={
              project?.projectBudget?.additionalFunding >
              project?.profile?.totalAdditionalFunding
                ? 'danger'
                : ''
            }
          >
            <CurrencyDisplay
              amount={project?.projectBudget?.additionalFunding}
            />
          </Text>
        </Descriptions.Item>
        <Descriptions.Item label="Deadline of Using Up Funding">
          <DateDisplay date={project?.profile?.deadlineOfUsingUpFunding} />
        </Descriptions.Item>
      </Descriptions>
    </Spin>
  );
};

export default BudgetHeaderCotent;
